module.exports = __webpack_public_path__ + "static/14-2-acc3d74dc5fc8f56c322923a657b2a1f.jpg";